import { message, notification } from 'antd';
import merge from 'lodash/merge';
import format from 'string-format';
import axios from 'axios';
import moment from 'moment';
import jsPDF from 'jspdf';
//import html2canvas from 'html2canvas';
import { LOCAL_STORAGE, CURRENCY, MESSAGE_TYPES, METHOD_TYPES } from './constants';
import { BRAND_INFO, BASE_URL, BASE_URL_USERS, NETWORK_CHECK_URL, MODULE_CONFIG } from './urls';
import { store } from '../../index';
import history from '../store/history'
import { resetReduxState } from '../redux/admin_details/actions';
import { updatePageState } from '../redux/page_details/actions';

export const log = (...arg) => {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.log(...arg);
  }
};

export const unregisterAllServiceWorker = () => { //TODO: temo func
  try {
    if (window.navigator && navigator.serviceWorker) {
      log('unregister service worker called')
      navigator.serviceWorker.getRegistrations()
        .then(function (registrations) {
          for (let registration of registrations) {
            registration.unregister()
          }
        })
    }
  } catch (error) {
    log('unregisterAllServiceWorker error')
  }
}

export const encrypt = (salt => {
  const textToChars = text => text.split('').map(c => c.charCodeAt(0))
  const byteHex = n => ("0" + Number(n).toString(16)).substr(-2)
  const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code)

  return text => text.split('')
    .map(textToChars)
    .map(applySaltToChar)
    .map(byteHex)
    .join('')
})(process.env.REACT_APP_CIPHER_SECRET_KEY)

export const getProcessedSelectedFilters = (selected_filters) => {
  let filters = {};
  if (selected_filters) {
    const selected_filter_keys = Object.keys(selected_filters);
    if (selected_filter_keys.length > 0) {
      selected_filter_keys.forEach(key => {
        if (selected_filters[key].length > 0) {
          selected_filters[key].forEach(filter_item => {
            if (filters[key] === undefined || filters[key] === null) {
              filters[key] = [];
            }
            filters[key] = [...filters[key], filter_item.value];
          })
        }
      });
    }
  }
  return filters;
};

const getHeaders = content_type => {
  let user = localStorage.getItem(LOCAL_STORAGE.ORI_ADMIN);
  user = user && (user != 'undefined') ? JSON.parse(localStorage.getItem(LOCAL_STORAGE.ORI_ADMIN)) : null;
  let headers = { 'Content-Type': content_type };
  if (user && user.token) {
    headers.Authorization = `bearer ${user.token}`
  }
  return headers;
};

export const fetchDataAndProceed = (
  url,
  method,
  data,
  callback,
  timeout = 20000,
  content_type = "application/json"
) => {
  let baseURL = BASE_URL;
  if (url.includes('/users') && BASE_URL_USERS) {
    baseURL = BASE_URL_USERS;
  }
  axios({
    method,
    params: method === METHOD_TYPES.GET ? data : {},
    data: method !== METHOD_TYPES.GET ? data : {},
    url,
    baseURL,
    headers: getHeaders(content_type),
    validateStatus: status => {
      return ((status >= 200 && status < 300) || status === 412);
    },
    timeout
  }).then(response => {
    callback(false, response.data);
  }).catch(error => {
    callback(true)
    if (error && error.message === "Network Error") {
      const is_internet_connected = store.getState().page_details.is_internet_connected
      if (is_internet_connected)
        store.dispatch(updatePageState(false, "is_internet_connected"))
    }
    if (error && error.code === 'ECONNABORTED') {
      message.warning('Request timeout. Let me check your connection..').then(() => {
        const checking_internet = store.getState().page_details.checking_internet
        const is_internet_connected = store.getState().page_details.is_internet_connected
        if (!checking_internet && is_internet_connected)
          checkInternetConnection()
      })
    }
    if (error && error.response) {
      if (error.response.status === 401) {
        localStorage.removeItem(LOCAL_STORAGE.ORI_ADMIN);
        localStorage.removeItem(LOCAL_STORAGE.LIVE_CHATS_UNREAD_MESSAGE_COUNT);
        store.dispatch(resetReduxState());
      }
      if (error.response.status === 800 && error.response.data && error.response.data.data && error.response.data.data.pathname)
        history.push(error.response.data.data.pathname)
      if (error.response.data && error.response.data.message)
        showMessage('error', error.response.data.message)
      else if (error.response.message)
        showMessage('error', error.response.message)
    }
  })
}

export const fetchWithTimeout = (url, options, timeout = 5000) => {
  return Promise.race([
    fetch(url, options),
    new Promise((_, reject) =>
      setTimeout(() => reject(new Error('timeout')), timeout)
    )
  ])
}

export const checkInternetConnection = callback => {
  if (navigator.onLine) {
    store.dispatch(updatePageState(true, "checking_internet"))
    fetchWithTimeout(NETWORK_CHECK_URL, {
      mode: 'no-cors',
    }).then(() => {
      store.dispatch(updatePageState(false, "checking_internet"))
      store.dispatch(updatePageState(true, "is_internet_connected"))
    }).catch(error => {
      store.dispatch(updatePageState(false, "checking_internet"))
      if (error && error.message === "timeout") {
        store.dispatch(updatePageState(false, "is_internet_connected"))
        if (callback)
          callback()
      }
    })
  } else
    store.dispatch(updatePageState(false, "is_internet_connected"))
}

const s4 = () => {
  return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
};

export const uniqueId = () => {
  let time = new Date().getTime();
  return `${time}${s4()}${s4()}${s4()}`;
};

export const debounced = (func, delay) => {
  let timerId;
  return (...args) => {
    if (timerId)
      clearTimeout(timerId);
    timerId = setTimeout(() => {
      func(...args);
      timerId = null;
    }, delay);
  }
}

export const checkPassword = password => {
  const pattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/;
  if (password.match(pattern)) {
    return true;
  } else {
    return false;
  }
};

export const createStringFromTemplate = (template, variables) => {
  const regexp = /{([^{]+)}/g;
  return template.replace(regexp, (_unused, key) => {
    return variables[key] === null ? '' : variables[key];
  });
}

export const removeStringLastCharacter = (str, endChar) => {
  if (str && str.length > 0 && str.charAt(str.length - 1) === endChar)
    str = str.substring(0, str.length - 1)
  return str
}

export const numberToColor = num => {
  num >>>= 0;
  var b = num & 0xFF,
    g = (num & 0xFF00) >>> 8,
    r = (num & 0xFF0000) >>> 16,
    a = ((num & 0xFF000000) >>> 24) / 255;
  return "rgba(" + [r, g, b, a].join(",") + ")";
}

export const stringToColour = (str, defaultColor = "#f3f0ff") => {
  var hash = 0;
  if (typeof str === 'number')
    return numberToColor(str)
  if (!str)
    return defaultColor
  for (var i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  var colour = '#';
  for (let i = 0; i < 3; i++) {
    var value = (hash >> (i * 8)) & 0xFF;
    colour += ('00' + value.toString(16)).substr(-2);
  }
  return colour;
}

export const openUrlInNewTab = url => {
  if (url && url.trim().length > 0) {
    let win = window.open(url, '_blank');
    win.focus();
  }
};

export const getUrlParams = () => {
  let params = {};
  window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => { params[key] = value; });
  return params;
}

export const isModuleAccessible = (permissions, path, parent_path) => {
  let isAllowed = false;
  if (path && permissions && permissions.features) {
    isAllowed = permissions.features[path] ? permissions.features[path].isAllowed : false;
    if (parent_path && permissions.features[parent_path] && permissions.features[parent_path].children && permissions.features[parent_path].children[path]) {
      isAllowed = permissions.features[parent_path].isAllowed && permissions.features[parent_path].children[path].isAllowed;
    }
  }
  return isAllowed;
}

export const isActionPermitted = (permissions, key, action) => {
  let isAllowed = true;
  if (permissions && permissions.actions && permissions.actions[key]) {
    isAllowed = permissions.actions[key][action];
  }
  return isAllowed;
}

export const isEventPermitted = (permissions, key) => {
  let isAllowed = true;
  if (permissions && permissions.events) {
    isAllowed = permissions.events[key];
  }
  return isAllowed;
}

export const moveCaretAtEnd = e => {
  let temp_value = e.target.value;
  e.target.value = '';
  e.target.value = temp_value;
};

export const showMessage = (type, msg, time, onClose) => {
  const Message = message[type];
  Message(msg, time, onClose);
};

export const showNotification = (type, message, description, placement) => {
  let payload = {};
  if (message) payload = { ...payload, message };
  if (description) payload = { ...payload, description };
  if (placement) payload = { ...payload, placement };
  notification[type](payload);
};

export const scrollToBottom = node => {
  if (node)
    node.scrollTop = node.scrollHeight;
};

export const filterArrayBySearchText = (text, array, key) => {
  return array.filter(item => {
    if (key)
      return (item[key] && item[key] !== undefined && item[key].toLowerCase().indexOf(text.toLowerCase()) !== -1);
    return (item && item !== undefined && item.toLowerCase().indexOf(text.toLowerCase()) !== -1);
  });
};

export const isImageExist = url => {
  if (url) {
    const img = new Image();
    img.src = url;
    if (!img.complete || img.height === 0) {
      return false;
    }
    return true;
  }
  return false;
};

export const refreshPage = () => {
  document.location.reload();
};

export const getAvatarBgClass = (name) => {
  let avatarBgClass = {};
  if (name) {
    const mod = name.length % 9;
    avatarBgClass = { "ori-bg-warning": mod === 0, "ori-bg-info": mod === 1, "ori-bg-violet": mod === 2, "ori-bg-green": mod === 3, "ori-bg-danger": mod === 4, "ori-bg-yellow": mod === 5, "ori-bg-magenta": mod === 6, "ori-bg-primary": mod === 7, "ori-bg-red": mod === 8 };
  }
  return avatarBgClass;
};

export const getLocalAdminDetails = () => {
  let details = localStorage.getItem(LOCAL_STORAGE.ORI_ADMIN);
  let oriAdminDetails = details && details !== undefined ? JSON.parse(localStorage.getItem(LOCAL_STORAGE.ORI_ADMIN)) : null;
  return oriAdminDetails;
};

export const getDataFromLocalStorage = (key, undefined_return_value) => {
  const data = localStorage.getItem(key);
  return (data && data !== undefined ? JSON.parse(data) : undefined_return_value);
};

export const setDataInLocalStorage = (key, data) => {
  const json_data = JSON.stringify(data);
  localStorage.setItem(key, json_data);
};

export const getAuthSocketData = publicIP => {
  const oriAdminDetails = getLocalAdminDetails();
  const auth_socket_data = {
    transportOptions: {
      polling: {
        extraHeaders: {
          'Authorization': oriAdminDetails && oriAdminDetails.token && oriAdminDetails.token.trim().length > 0 ? oriAdminDetails.token : null
        }
      }
    },
    query: {
      role: BRAND_INFO.data.socket_query.role,
      channelName: BRAND_INFO.data.socket_query.channelName,
      psid: oriAdminDetails && oriAdminDetails.admin_id && oriAdminDetails.admin_id.trim().length > 0 ? oriAdminDetails.admin_id : null,
      brandName: BRAND_INFO.data.socket_query.brandName,
      _id: oriAdminDetails && oriAdminDetails._id && oriAdminDetails._id.trim().length > 0 ? oriAdminDetails._id : null,
      publicIP
    },
    timeout: 10000
  };
  return auth_socket_data;
};

export const formatPrice = (price, currency) => {
  switch (currency) {
    case CURRENCY.RUPEES:
      return Intl.NumberFormat("en-In", { style: "currency", currency: "INR" }).format(price);
    case CURRENCY.DOLLAR:
      return Intl.NumberFormat("en-In", { style: "currency", currency: "USD" }).format(price);
    default:
      return price;
  }
};

export const formatDate = (value, option) => {
  let date = new Date(value);
  return date.toLocaleDateString('en-In', option);
};

export const getCurrentTime = (option) => {
  let date = new Date();
  const current_time = moment(date).format(option)
  return current_time;
};

export const getLang = function () {
  return (navigator.languages && navigator.languages.length) ? navigator.languages[0].split('-')[0] : navigator.language.split('-')[0];
};

export const setTitleAsPath = function () {
  if (window.location.pathname === "/")
    document.title = "dashboard";
  else
    document.title = window.location.pathname.replace("/", "");
}

const addtoPDF = obj => {
  let { doc, line, text } = obj;
  let strArr = doc.splitTextToSize(text, 180);
  strArr.forEach(txt => {
    doc.text(txt, 10, line);
    line = increment({ doc, line })
  })
  return line
}
const btndisplay = (obj) => {
  let { doc, line, btn } = obj;
  if (btn.text) {
    doc.text(`• ${btn.text}`, 20, line);
    line = increment({ doc, line })
  }
  return line
}
const increment = (obj) => {
  let { doc, line } = obj;
  line = line + 5;
  if (line >= 280) {
    doc.addPage();
    line = 25; //reset to default
  }
  return line
}

export const downloadChatlogTranscript = ({ filename, messages }) => {
  //window.html2canvas=html2canvas
  let line = 25;
  let chats = "";
  let doc = new jsPDF();
  doc.setFontSize(8);
  messages.forEach((e) => {
    let date = formatDate(e.timestamp, { year: "numeric", month: "short", day: "numeric" })
    let time = moment(e.timestamp).format("hh:mm A")
    const sender = (e.sender == "admin") ? e.senderInfo.pseudoName : e.sender

    //title
    let t1 = e.payload.title && e.payload.title.length > 0 ? e.payload.title : ""

    //subtitle
    let subtitl = e.payload.subtitle && e.payload.subtitle.length > 0 ? e.payload.subtitle : ""

    //imageURL
    let imgurl = e.payload.imageUrl && e.payload.imageUrl.length > 0 ? e.payload.imageUrl : ""

    //videoUrl
    let vurl = e.payload.url && e.payload.url.length > 0 ? e.payload.url : ""

    var text = "";
    var strArray;

    if (e.type == MESSAGE_TYPES.TEXT) {
      text = `${date} ${time}:- ${sender}: ${e.payload.text}`;
      line = addtoPDF({ doc, line, text })
      log("back", line);
      if (e.containsHTML) {
        const content = e.payload.text;
        chats = chats + `<div>${content}</div>`
      }
    } else if (e.type == MESSAGE_TYPES.TEXT_WITH_BUTTONS) {
      text = `${date} ${time}:- ${sender}: ${subtitl} `;
      log('my line num', line);
      line = addtoPDF({ doc, line, text })
      if (e.payload.buttons) {
        doc.text("Select options:", 15, line);
        line = line + 5;
        e.payload.buttons.forEach(btn => {
          line = btndisplay({ btn, line, doc })
        })
      }
    } else if (e.type == MESSAGE_TYPES.IMAGE_WITH_BUTTONS) {
      doc.text(`${date} ${time}:- ${sender}: `, 10, line);
      line = line + 5;
      doc.setTextColor(0, 0, 255);
      doc.textWithLink(`Image Link`, 40, line, { url: imgurl });
      doc.setTextColor(0, 0, 0);
      if (e.payload.buttons) {
        doc.text("Select options:", 15, line);
        line = line + 5;
        e.payload.buttons.forEach(btn => {
          line = btndisplay({ btn, line, doc })
        })
      }
    } else if (e.type == MESSAGE_TYPES.CAROUSEL) {
      text = `${date} ${time}:- ${sender}: ${t1} ${subtitl} `
      line = addtoPDF({ doc, line, text })
      if (e.payload.options) {
        let numflag = false;
        e.payload.options.forEach((option, i) => {
          let num = i + 1;
          if (option.title) {
            strArray = doc.splitTextToSize(`${num}. ${option.title}`, 180);
            numflag = true;
            strArray.forEach(text => {
              doc.text(text, 15, line);
              line = increment({ line, doc })
            })

          }
          if (option.subtitle) {
            if (numflag) {
              doc.text(` ${option.subtitle}`, 20, line);
            }
            else {
              doc.text(`${num}. ${option.subtitle}`, 15, line);
              numflag = true;
            }

            line = increment({ line, doc })
          }
          if (option.mediaUrl) {
            if (numflag) {
              doc.text('Image Link', 21, line);
            }
            else {
              doc.text(`${num}. Image Link`, 15, line);
              numflag = true;
            }

            doc.setTextColor(0, 0, 255);
            doc.textWithLink(`OPEN`, 40, line, { url: option.mediaUrl });
            doc.setTextColor(0, 0, 0);
            line = increment({ line, doc })
          }
          if (option.buttons) {
            doc.text("Select options:", 15, line);
            line = line + 5;
            option.buttons.forEach((btn) => {
              line = btndisplay({ btn, line, doc })
            })
          }
        })
      }
      if (e.payload.buttons) {
        doc.text("Select options:", 15, line);
        line = line + 5;
        e.payload.buttons.forEach(btn => {
          line = btndisplay({ btn, line, doc })
        })
      }
    } else if (e.type == MESSAGE_TYPES.VIDEO) {
      text = `${date} ${time}:- ${sender}:${t1} ${subtitl}`
      line = addtoPDF({ doc, line, text })
      doc.text('Video Link', 10, line);
      doc.setTextColor(0, 0, 255);
      doc.textWithLink(`OPEN`, 40, line, { url: vurl });
      doc.setTextColor(0, 0, 0);
      line = increment({ line, doc })
    } else if (e.type == MESSAGE_TYPES.CHECKBOX_WITH_MEDIA) {
      text = `${date} ${time}:- ${sender}:${t1} ${subtitl} `
      if (e.payload.options) {
        e.payload.options.forEach(option => {
          if (option.label) {
            doc.text(`LABEL: ${option.label}`, 10, line);
            line = increment({ line, doc })
          }
        })
      }
      if (e.payload.buttons) {
        doc.text("Select options:", 15, line);
        line = line + 5;
        e.payload.buttons.forEach(btn => {
          line = btndisplay({ btn, line, doc })
        })
      }
      doc.text('Image Link', 10, line);
      doc.setTextColor(0, 0, 255);
      doc.textWithLink(`OPEN`, 40, line, { url: imgurl });
      doc.setTextColor(0, 0, 0);
    } else if (e.type == MESSAGE_TYPES.CUSTOM_MSG) {
      // chats += `${date} ${time}:- ${sender}:${t1} ${subtitl} ${btnarr} \r\n`
      text = `${date} ${time}:- ${sender}:${t1} ${subtitl}`;
      line = addtoPDF({ doc, line, text })
      e.payload.buttons.forEach(btn => {
        line = btndisplay({ btn, line, doc })
      })
    }
  })
  doc.save(filename)
}

export const histogramLabelFormatter = val => {
  if (val.length > MODULE_CONFIG.GLOBAL.HISTOGRAM_X_AXIS_CHARACTER_SPLIT_COUNT) {
    if (val.indexOf(' ', 10) < MODULE_CONFIG.GLOBAL.HISTOGRAM_X_AXIS_CHARACTER_SPLIT_COUNT)
      return `${val.substring(0, val.indexOf(' ', 10))}\n${val.substring(val.indexOf(' ', 10), val.length)}`
    else if (val.indexOf(' ', 10) > MODULE_CONFIG.GLOBAL.HISTOGRAM_X_AXIS_CHARACTER_SPLIT_COUNT)
      return `${val.substring(0, val.length / 2)}-\n${val.substring(val.length / 2, val.length)}`
  }
  return val
}

//-------------------------- To Get Device information -------------------------

export const checkDevice = {
  isMobile: function () {
    if (navigator.userAgent.match(/Android/i)) {
      return ({
        mobile: true,
        userAgent: 'Android'
      });
    } else if (navigator.userAgent.match(/BlackBerry/i)) {
      return ({
        mobile: true,
        userAgent: 'BlackBerry'
      });
    } else if (navigator.userAgent.match(/iPhone|iPod/i)) {
      return ({
        mobile: true,
        userAgent: 'iPhone'
      });
    } else if (navigator.userAgent.match(/iPad/i)) {
      return ({
        mobile: false,
        userAgent: 'iPad'
      });
    } else if (navigator.userAgent.match(/Opera Mini/i)) {
      return ({
        mobile: true,
        userAgent: 'Opera'
      });
    } else if (navigator.userAgent.match(/IEMobile/i)) {
      return ({
        mobile: true,
        userAgent: 'WindowsPhone'
      });
    } else if (navigator.userAgent.match(/Chrome/i)) {
      return ({
        mobile: false,
        userAgent: 'Web Chrome'
      });
    } else if (navigator.userAgent.match(/Safari/i)) {
      return ({
        mobile: false,
        userAgent: 'Web Safari'
      });
    } else if (navigator.userAgent.match(/Mozilla/i)) {
      return ({
        mobile: false,
        userAgent: 'Web Mozilla'
      });
    } else {
      return ({
        mobile: false,
        userAgent: 'Web'
      });
    }
  },
  screen_data: function () {
    return (
      {
        screen_width: window.innerWidth,
        screen_height: window.innerHeight,
        screen_orientation: this.screen_orientation(),
        screen_type: this.screen_type()
      }
    );
  },
  screen_orientation: function () {
    if (window.matchMedia("(orientation:landscape)").matches) {
      return 'landscape';
    } else {
      return 'portrait';
    }
  },
  screen_type: function () {
    if (window.innerWidth <= 480) {
      return 'xs';
    } else if (window.innerWidth <= 768) {
      return 'sm';
    } else if (window.innerWidth <= 992) {
      return 'md';
    } else if (window.innerWidth <= 1200) {
      return 'lg';
    } else if (window.innerWidth <= 1600) {
      return 'hd';
    } else if (window.innerWidth <= 2560) {
      return 'fhd';
    } else {
      return 'uhd';
    }
  },
  deviceStatus: function () {
    return ({
      ...this.isMobile(),
      ...this.screen_data()
    });
  }
};

//-------------------------- get Message JSON ---------------------------


export const generateMessageObject = (message_doc, contextVariablesData) => {
  log('​exportgenerateMessageObject -> message_doc', message_doc);
  log('​exportgenerateMessageObject -> contextVariablesData', contextVariablesData);
  try {
    let payload = {};
    const message_type = message_doc.type;
    if (message_type == MESSAGE_TYPES.TEXT) {
      payload.text = message_doc.text ? format(message_doc.text, contextVariablesData) : '';
    } else if (message_type === MESSAGE_TYPES.IMAGE_WITH_BUTTONS || message_type === MESSAGE_TYPES.TEXT_WITH_BUTTONS) {
      if (message_type === MESSAGE_TYPES.IMAGE_WITH_BUTTONS) {
        payload.imageUrl = message_doc.imageUrl;
      }
      const buttons = message_doc.buttons;
      const buttons_array = processButtonsArray(buttons, contextVariablesData);
      payload.buttons = buttons_array;
      payload.title = message_doc.title ? format(message_doc.title, contextVariablesData) : '';
      payload.subtitle = message_doc.subtitle ? format(message_doc.subtitle, contextVariablesData) : '';
    } else if (message_type === MESSAGE_TYPES.LINK) {
      const buttons = message_doc.buttons;
      const buttons_array = processButtonsArray(buttons, contextVariablesData);
      payload.buttons = buttons_array;
      payload.title = message_doc.title ? format(message_doc.title, contextVariablesData) : '';
      payload.subtitle = message_doc.subtitle ? format(message_doc.subtitle, contextVariablesData) : '';
    } else if (message_type === MESSAGE_TYPES.CAROUSEL) {
      const images = [];
      if (message_doc.images) {
        for (let i = 0; i < message_doc.images.length; i++) {
          images.push({ url: message_doc.images[i].url, caption: message_doc.images[i].caption });
        }
        // not sure about this.
        payload.images = images;
      }
      payload.title = message_doc.title ? format(message_doc.title, contextVariablesData) : '';
      payload.subtitle = message_doc.subtitle ? format(message_doc.subtitle, contextVariablesData) : '';
      payload.options = message_doc.options;
      const buttons = message_doc.buttons;
      const buttons_array = processButtonsArray(buttons, contextVariablesData);
      payload.buttons = buttons_array;
    } else if (message_type === MESSAGE_TYPES.TIMER) {
      payload.duration = message_doc.duration;
      payload.next_msg_id = message_doc.next_msg_id;
    } else if (message_type === MESSAGE_TYPES.VIDEO) {
      payload.title = message_doc.title ? format(message_doc.title, contextVariablesData) : '';
      payload.subtitle = message_doc.subtitle ? format(message_doc.subtitle, contextVariablesData) : '';
      payload.url = message_doc.url;
    } else if (message_type === MESSAGE_TYPES.CUSTOM_MSG) {
      payload.imageUrl = (message_doc.imageUrl) ? message_doc.imageUrl : null;
      const images = [];
      if (message_doc.images) {
        for (let i = 0; i < message_doc.images.length; i++) {
          images.push({ url: message_doc.images[i].url, caption: message_doc.images[i].caption });
        }
        payload.images = images;
      }
      payload.text = message_doc.text ? format(message_doc.text, contextVariablesData) : null;
      payload.subtype = message_doc.subtype ? message_doc.subtype : null;
      payload.title = message_doc.title ? format(message_doc.title, contextVariablesData) : null;
      payload.subtitle = message_doc.subtitle ? format(message_doc.subtitle, contextVariablesData) : null;
      const buttons = (message_doc.buttons && message_doc.buttons.length > 0) ? message_doc.buttons : null;
      payload.buttons = null;
      const data_obj = {};
      if (message_doc.data) {
        for (let j = 0; j < message_doc.data.length; j++) {
          data_obj[message_doc.data[j]] = (contextVariablesData[message_doc.data[j]]) ? contextVariablesData[message_doc.data[j]] : null;
        }
        payload.data = data_obj;
      }
      message_doc.raw_data = message_doc.raw_data ? message_doc.raw_data : {};
      payload.data = merge({}, payload.data, message_doc.raw_data);
      if (buttons) {
        const buttons_array = processButtonsArray(buttons, contextVariablesData);
        payload.buttons = buttons_array;
      }
    }

    const msgToSend = {
      expectedClientResponseType: message_doc.expectedClientResponseType ? message_doc.expectedClientResponseType : null,
      send_variable_to_apiai: message_doc.send_variable_to_apiai ? message_doc.send_variable_to_apiai : false,
      sendVariableToLS: message_doc.sendVariableToLS ? message_doc.sendVariableToLS : false,
      type: message_type,
      delay: message_doc.delay ? message_doc.delay : 0,
      inputLock: message_doc.inputLock ? message_doc.inputLock : false,
      skipLS: message_doc.skipLS ? message_doc.skipLS : false,
      variable_name: message_doc.variable_name ? message_doc.variable_name : '',
      payload,
      sender: 'chatbot',
      timestamp: new Date(),
      quickReplies: message_doc.quickReplies,
    };
    return msgToSend;
  } catch (err) {
    log('an error occoured during message object creation :-', err);
  }
}

const processButtonsArray = (buttons, contextVariablesData) => {
  const buttons_array = [];
  if (buttons && buttons.length > 0) {
    for (let i = 0; i < buttons.length; i++) {
      const button = buttons[i];
      const buttonKeys = Object.keys(button);
      if (button.text && button.type) {
        buttonKeys.map((key) => {
          if (key === 'text') {
            button[key] = format(button[key], contextVariablesData);
          }
          button[key] = button[key];
        });
        buttons_array.push(button);
      } else if (button.text) {
        buttons_array.push({
          text: format(button.text, contextVariablesData),
          type: 'default'
        });
      }
    }
  }
  return buttons_array;
}

//--------------------------END of get Message JSON ---------------------------




// WEBPACK FOOTER //
// ./src/data/config/utils.js